import {http} from '@/http'

export default {
  getDistricts() {
    return http.get('/api/v1/districts')
  },
  getBasePrices(routeType) {
    return http.get('/api/v1/base-prices', {params: {route_type: routeType}})
  },
  updateBasePrices(items) {
    return http.put('/api/v1/base-prices', {items})
  },
  getCalculatedPrices(routeType) {
    return http.get('/api/v1/calculated-prices', {params: {route_type: routeType}})
  }
}
